import { FC } from "react";
import { Box, Link } from "@mui/material";
import { useStyles } from "./styles";

import IconTwitter from "../../assets/images/about/twitter.svg";
import IconLinkedIn from "../../assets/images/about/linkedin.svg";
import ImgMainBg from "../../assets/images/about/team_main_bg.png";

interface Props {
  id: number;
  name: string;
  position: string;
  shortPosition: string;
  image: string;
  twitter: string;
  linkedin: string;
  description: string;
  direction: string;
  inMobile: boolean;
}

const TeamMember: FC<Props> = ({
  name,
  position,
  shortPosition,
  image,
  twitter,
  linkedin,
  description,
  direction,
  inMobile,
}) => {
  const classes = useStyles();

  if (inMobile) {
    return (
      <Box className={classes.root}>
        <Box className={classes.topSection}>
          <Box className={classes.photoWrapper}>
            <Box className={classes.photoMask} />
            <Box className={classes.photoImg}>
              <img src={image} alt="Avatar" />
            </Box>
          </Box>
          <Box className={classes.shortTitle}>{shortPosition}</Box>
        </Box>
        <Box className={classes.main}>
          <Box className={classes.name}>
            <Box className={classes.socialIcon}>
              <Link href={twitter}>
                <img src={IconTwitter} alt="Twitter" />
              </Link>
            </Box>
            <Box px={1} flex={1}>{name}</Box>
            <Box className={classes.socialIcon}>
              <Link href={linkedin}>
                <img src={IconLinkedIn} alt="LinkedIn" />
              </Link>
            </Box>
          </Box>
          <Box className={classes.title}>{position}</Box>
          <Box className={classes.description}>{description}</Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      className={classes.root}
      sx={{
        flexDirection: direction === "right" ? "row-reverse" : "row",
        marginLeft: direction === "right" ? "-10rem" : 0,
        marginRight: direction === "right" ? 0 : "-10rem",
      }}
    >
      <Box className={classes.socials}>
        <Box className={classes.socialIcon}>
          <Link href={twitter}>
            <img src={IconTwitter} alt="Twitter" />
          </Link>
        </Box>
        <Box className={classes.socialIcon}>
          <Link href={linkedin}>
            <img src={IconLinkedIn} alt="LinkedIn" />
          </Link>
        </Box>
      </Box>

      <Box className={classes.photoWrapper}>
        <Box className={classes.photoMask} />
        <Box className={classes.photoImg}>
          <img src={image} alt="Avatar" />
        </Box>
      </Box>

      <Box
        className={classes.main}
        sx={{
          backgroundImage: `url(${ImgMainBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          paddingLeft: direction === "right" ? "10rem" : "4rem",
          paddingRight: direction === "right" ? "4rem" : "10rem",
        }}
      >
        <Box className={classes.name}>{name}</Box>
        <Box className={classes.title}>{position}</Box>
        <Box className={classes.description}>{description}</Box>
      </Box>
    </Box>
  );
};

export default TeamMember;
